module.exports = __webpack_public_path__ + "img/imag.2443abd7.png";